import React from "react";
import styled from "styled-components";


const Input = ({type, icon, placeholder, name, value, onChange, onKeyDown}) => {
    return(
        <Container>
            <Icon src={icon} alt="input icon"/>
            <TextInput type={type} placeholder={placeholder} name={name} value={value} onChange={onChange} onKeyDown={onKeyDown ? onKeyDown : () => {}}/>
        </Container>
    )
}
export default React.memo(Input);

const Container = styled.div`
    position: relative;
    width: 100%;
    height: 48px;
    border-radius: 12px;
    overflow: hidden;
`
const TextInput = styled.input`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0px 40px;
    font-size: 16px;
    border-radius: 12px;
    border: 1px solid #ccc;
`

const Icon = styled.img`
      position: absolute;
      top: 0;
      bottom: 0;
      left: 12px;
      margin: auto;
      z-index: 1;
`